<div class="position-relative h-100vh">
  <div class="widget-loader">
    <ces-loaders
      *ngIf="loader"
      type="spinner"
      size="medium"
      textPosition="center"
    ></ces-loaders>
  </div>
</div>
